/* eslint-disable no-underscore-dangle */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable class-methods-use-this */
import React, { Component } from 'react';
import { defineMessages, injectIntl } from 'react-intl';
import {
  FormControl,
  TextField,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';

const messages = defineMessages({
  hours: {
    id: 'CoursePlan.hours',
    defaultMessage: 'Number of hours',
  },
});

class CoursePlanHours extends Component {
  renderTextField({
    input,
    label,
    ...custom
  }) {
    return (
      <TextField
        label={label}
        {...input}
        {...custom}
      />
    );
  }

  render() {
    const { intl } = this.props;
    return (
      <FormControl variant="outlined" style={{ width: '100%' }}>
        <Field
          name="duration"
          id="filled-number"
          label={intl.formatMessage(messages.hours)}
          style={{ width: '100%' }}
          variant="outlined"
          type="number"
          inputProps={{ min: '0', step: '0.5' }}
          component={this.renderTextField}
        />
      </FormControl>
    );
  }
}

CoursePlanHours.propTypes = {
  intl: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  const name = `group_${state.group.selectedGroup._id}`;
  const dataform = state.form[`group_${state.group.selectedGroup._id}`];
  return ({ initialValues: state.group.selectedGroup, form: name, dataform });
}

const connectedGroupForm = reduxForm({
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false,

})(injectIntl(CoursePlanHours));

const NewconnectedGroupForm = connect(mapStateToProps, {})(connectedGroupForm);

export default (NewconnectedGroupForm);
